
export default {

    common_loading: 'Loading',
    common_cancel: 'Cancel',
    common_confirm: 'Confirm',
    common_continue: 'Continue',
    common_submit: 'Submit',
    common_token_expire: 'The token has expired, please log in again.',
    common_modify_success: 'Modify successful',
    common_success: 'Successful',

    common_home: 'Home',
    common_market: 'Market',
    common_msgs: 'Msgs',
    common_find: 'Find',
    common_me: 'Me',

    common_deposit: 'Deposit',
    common_withdraw: 'Withdraw',
    common_team: 'TEAM',
    common_channel: 'CHANNEL',
    common_service: 'SERVICE',
    common_currency: 'CURRENCY',
    common_more: 'MORE',
    common_detail: 'DETAIL',
    common_search: 'Search',
    common_language: 'Language',
    common_share: 'Share',
    common_logout: 'Logout',
    common_copy_success: 'Copy successfully',
    common_send: 'SEND',
    common_empty_data: 'No Data',
    common_created: 'Created',
    common_time: 'Time',
    common_download_app: 'Download APP',
    common_download: 'Download',

    toast_input_phone: 'Please input phone number',
    toast_input_password: 'Please input password',
    toast_input_full_name: 'Please input full name',
    toast_input_email: 'Please input email',
    toast_input_refcode: 'Please input ref code',
    toast_input_old_password: 'Please input old password',
    toast_input_new_password: 'Please input new password',
    toast_input_repeat_password: 'Please input repeat password',
    toast_input_repeat_password_nosame: 'The two passwords are different',
    toast_input_phone_length: 'phone number cannot be less than 10 digits',

    login_welcome: 'Welcome to back!',
    login_subtitle: 'SIGN INTO YOUR ACCOUNT',
    login_no_account: 'Don\'t have an account?',
    register_title: 'Create an account',
    register_subtitle: 'Let\'s get started with a free quant trading account',
    register_have_account: 'Already have an account?',
    
    user_phone: 'Mobile phone number(9 Number)',
    user_password: 'Password',
    user_forget_password: 'Forget password?',
    user_sign_in: 'Sign in',
    user_sign_up: 'Sign up',
    user_full_name: 'Full name',
    user_email: 'Email',
    user_verife_code: 'Verification Code',
    user_ref_code: 'Ref code',
    user_old_password: 'Old Password',
    user_new_password: 'New Password',
    user_repeat_password: 'Repeat Password',
    user_find_password: 'Find My Password',
    user_modify_password: 'Modify My Password',
    user_modify_login_password: 'Modify login password',
    user_account_security: 'Account Security',

    user_center: 'User Center',
    user_invite_reward_title: 'EARN AT LEAST 10% BONUS',
    user_invite_reward_desc: 'Invite friends to join get bonus not limited',
    user_invite_records: 'Invitation reward record',
    user_security_protect: 'Protect account security',

    user_kefu_title1: 'Contact Us',
    user_kefu_title2: 'UNDER METHODS',
    user_kefu_24hour_hint: '24-hour online customer service',
    user_kefu_notice: 'When the invited user recharges, the reward will be automatically added to your account balance',
    user_invited: 'invited',

    share_hint: 'When the invited user recharges, the reward will be automatically added to your account balance',
    share_copy_link: 'Copy link and share',
    share_rewards_record: 'Rewards Record',
    
    home_total_asset_value: 'TOTAL ASSET VALUE',
    
    msg_msgs: 'MsgS',
    msg_contacts: 'Contacts',

    wallet_balance: 'Balance',
    wallet_salary_balance: 'Salary Balance',
    wallet_update_bank: 'Update withdrawal bank',
    wallet_account_settlement: 'Account Settlement',
    wallet_payroll_records: 'Payroll Records',
    wallet_financial_records: 'Financial records',
    wallet_trade_history: 'Transaction History',
    wallet_update_bank_info: 'UPDATE BANK INFORMATION',
    wallet_update_bank_hint: 'The same account can only be bound to one account',
    wallet_update_bank_input_name: 'Please input name',
    wallet_update_bank_input_cardno: 'Withdrawal Application Account (number)',
    wallet_update_bank_input_ifsc: 'Please input SWIFT Code',
    wallet_update_bank_input_bankname: 'Please input bank name',
    wallet_update_bank_input_otp: 'Please input branch otp',
    wallet_bind_bank_message: 'I haven\'t bind my bank card yet. Do you want to bind it now?',
    wallet_bind_bank_go: 'goto bind',

    deposit_recommend_amount: 'Recommended amount',
    deposit_select_channel_title: 'Please select a recharge channel',

    withdraw_available_balance: 'Available Balance',
    withdraw_amount: 'Amount',
    withdraw_taxs: 'Taxs',
    withdraw_total_amount: 'Total Amount',
    withdraw_select_bank: 'SELECT BANK',
    withdraw_notice: 'Withdrawal charges 20% Taxs, withdraw time Monday-Friday 7am-9am,2,Salary Withdrawal time Monday-Sunday 7am-9am',
    withdraw_password_modify_title: 'Modify withdrawl password',
    withdraw_set_paypassword_message: 'I haven\'t set a withdrawl password yet. Do you want to set one now?',
    withdraw_pay_password_input: 'Please input withdrawl password',

    trade_ordering: 'Trading Pairs',
    trade_history: 'History',
    trade_past_24: 'Past 24 Hours',
    trade_market_detail: 'Market details',
    trade_open_price: 'Open Price',
    trade_vol: 'Vol',
    trade_high: 'High', 
    trade_low: 'Low',
    trade_call: 'CALL',
    trade_put: 'PUT',
    trade_path: 'Path',
    trade_signal_rate: 'Signal Rate',
    trade_position: 'Position',
    trade_status: 'Status',
    trade_waiting: 'Waiting',
    trade_profit: 'Profit',
    trade_loss: 'Loss',
    trade_settlement: 'Settlement',
    trade_product: 'Product',
    trade_close_price: 'Close Price',
    trade_order_detail : 'ORDER DETAIL',

    chat_message_deleted: 'This message was deleted',
    chat_message_empty: "No messages",
    chat_conversation_started: 'Conversation started on:',
    chat_type_message: 'Type message',
    chat_reply: 'Reply',

    channel_signal: 'SIGNAL CHANNEL',

    team_level_1: 'Level-1',
    team_level_2: 'Level-2',
    team_level_3: 'Level-3',
    team_reg_num: 'Total number of registered',
    team_recharge_num: 'Total number of rechargers',
    team_recharged: 'Recharged',
    team_unrecharge: 'Not recharged',

    /******************************************/
    user_remember_password: 'Remember password',
    common_trade: 'Trade',
    common_time: 'Time',
    currency_name: 'Name',
    currency_latest_price: 'Latest price',
    currency_rise_and_fall: 'Rise and fall',
    trade_high_today: 'high today',
    trade_low_today: 'low today',
    trade_direction: 'direction',
    trade_buy_more: "CALL",
    trade_buy_less: "PUT",
    time_min: 'min',
    time_hour: 'hour',
    time_day: 'day',
    time_week: 'week',
    time_mon: 'mon',

    follow_order_title: 'Follow top traders and earn money',
    follow_order_desc: 'You can copy the strategies of excellent traders, automatically follow orders, and earn profits',
    common_now_try: 'experience now',

    welfare_activity_title: 'Latest welfare activities',
    welfare_activity_desc: 'Please keep an eye on the news on the home page to learn about our latest event policy!',
    appdownload:'DOWNLOAD',
    welfarecenter:'Welfare Center',

}